module.exports = __webpack_public_path__ + "img/icon_年.fdf5e5ca.svg";